import Repository from './Repository';

class ConnectionRepository extends Repository {
	/**
	 * Resolves an array of connection objects from the API.
	 *
	 * @param client
	 * @param connection
	 * @returns {Promise<array>}
	 */
	all (client = null, connection = false) {
		const includes = [
			'translator'
		].join(',');

		let clientQuery = '';

		if (!connection) {
			const clientId = client ? client.id : null;
			clientQuery = `client=${clientId}&`;
		}

		return this.getWithToken(`/connections?${clientQuery}include=${includes}`);
	}

	/**
	 * send request to deactivate a connection
	 *
	 * @param {int} id
	 * @returns {Promise<Array|Object|string>}
	 */
	deactivate (id) {
		return this.deleteWithToken(`/connections/${id}/deactivate`);
	}

	fetchDevices (connectionId, page, withAttribute = null) {
		let url = `/connections/${connectionId}/devices?page=${page}`;

		if (withAttribute) {
			url += '&withAttribute=' + withAttribute;
		}

		return this.getWithToken(url);
	}

	/**
	 * get details for a connection
	 *
	 * @param id
	 * @returns {Promise<Array|Object|string>}
	 */
	fetchConnection (id) {
		return this.getWithToken(`/connections/${id}`);
	}

	/**
	 * make an api call to sync selected connections
	 *
	 * @param ids
	 * @returns {Promise<Array|Object|string>}
	 */
	syncSelectedConnections (ids) {
		return this.postWithToken('/connections/sync-selected', { connections: ids });
	}

	fetchDeviceTypeAttributes (connectionId) {
		return this.getWithToken(`/connections/${connectionId}/device-type-attributes`);
	}
}

export default new ConnectionRepository();
